import React from 'react';
import Container from '../../../containers/master/courses/createCourseContainer';

export default function () {
  return (
    <Container />
  );
}
